<div class="bm--auth-form-box">
  <h1 class="common-section-title common-section-title--form">Forgot password?</h1>

  <div class="restore-password-page__form-box">
    <bmcore-restore-password-form></bmcore-restore-password-form>
  </div>

  <div class="restore-password-page__hint-box">
    <p class="bm--auth-form__hint bm--auth-form__hint--text">Did you remember your password?</p>
    <a class="bm--auth-form__hint bm--auth-form__hint--link" routerLink="/sign-in">Sign In</a>
  </div>
</div>
